import { Result } from "appworks/model/gameplay/records/results/result";

export class AgsTrailStateResult extends Result {
    /** For debugging purposes */
    public resultType: string = "AgsTrailStateResult";
    public trailLevel: number;
}
